var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('ReportSidebar',{attrs:{"saving":_vm.saving},on:{"save":_vm.save}}),_vm._v(" "),_c('ValidationObserver',{staticClass:"block w-full h-screen-min-header pb-10 overflow-x-hidden overflow-y-scroll",attrs:{"id":"container"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var valid = ref.valid;
return [_c('ReportPages',{attrs:{"valid":valid}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }